export enum PageId {
  HOME = 'HOME',
  REQUEST_FIGURANT = 'REQUEST_FIGURANT',
  ORDER_FIGURANT_AGENCY = 'ORDER_FIGURANT_AGENCY',
  CHECK_ORDER = 'CHECK_ORDER',
  GENERATE_INVOICE_LETTER = 'GENERATE_INVOICE_LETTER',
  PERMIT = 'PERMIT',
}

export const PAGE_MAPPINGS = [
  {
    url: '/',
    id: PageId.HOME,
  },
  { url: '/solicitacao-figurante', id: PageId.REQUEST_FIGURANT },
  { url: '/pedidos', id: PageId.ORDER_FIGURANT_AGENCY },
  { url: '/conferir-pedidos', id: PageId.CHECK_ORDER },
  { url: '/gerar-carta-fatura', id: PageId.GENERATE_INVOICE_LETTER },
  { url: '/alvara', id: PageId.PERMIT },
];

/**
 * Retorna o PageId correspondente para uma URL dada.
 * Se nenhuma correspondência for encontrada, retorna PageId.GERAL como padrão.
 *
 * @param url - A URL a ser comparada com as URLs de página conhecidas.
 * @returns O PageId associado à URL fornecida.
 */
export function getPageId({ url }: { url: string }): PageId {
  const mapping = PAGE_MAPPINGS.find(mapping => url.includes(mapping.url));
  return mapping ? mapping.id : PageId.HOME;
}
